import React from "react";
import { useTranslation } from "react-i18next";
import { css } from "@emotion/css";
import Divider from "@mui/material/Divider";
import DatabasePicker from "../other/StartRunDatabasePicker";

const classes = {
    instruction: css`
        margin: 10px 0;
        font-weight: bold;
    `,
    divider: css`
        margin: 10px 0;
    `,
};

const SelectPopulationDatabase = (props) => {
    const { t } = useTranslation();

    return (
        <div>
            <div className={classes.instruction}>1b. {t("Select population database")}</div>

            <DatabasePicker
                databaseType={props.populationDatabaseType}
                defaultDatabases={props.defaultDatabases}
                customDatabases={props.customDatabases}
                selectedDatabaseId={props.selectedPopulationDatabaseId}
                uploadedDatabaseName={props.uploadedPopulationDatabaseName}
                databaseUploadProgress={props.populationDatabaseUploadProgress}
                uploadingDatabase={props.uploadingPopulationDatabase}
                onChangeDatabaseType={props.onChangePopulationDatabaseType}
                onSelectDatabase={props.onSelectPopulationDatabase}
                onSelectDatabaseFile={props.onSelectPopulationDatabaseFile}
                onUploadDatabase={props.onUploadPopulationDatabase}
                onCancelDatabaseUpload={props.onCancelPopulationDatabaseUpload}
            />

            <Divider className={classes.divider} />
        </div>
    );
};

export default SelectPopulationDatabase;
